import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=0ab4d48d&"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports